import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { Button, Card, Container, Modal } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import './Series.scss';
import { useQuery } from '../../../hooks/useQuery';
import { faArrowLeft, faFilm, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VideoRating } from '../../components/VideoRating/VideoRating';
import { MyListButton } from '../../components/MyListButton/MyListButton';
import { Video } from '../../components/Video/Video';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { SubscribeButton } from '../../components/SubscribeButton/SubscribeButton';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';
import { CountryFlag } from '../../components/CountryFlag/CountryFlag';
import { shouldSeeAdv, trackVideoRecommendation } from '../../utils/utils';
import { isWithinInterval } from 'date-fns';

const SeriesComponent = () => {
  const { getSeries, series, staticData, userDataFmt, database, fv, updateUserData, currentUser, isVideoLocked } = useFirebase();
  const { id } = useParams<any>();
  const { hl } = useQuery();
  const history = useHistory();
  const { currentLanguage } = useCurrentLanguage();
  const [serie, setSerie] = useState(null);
  const [trailer, setTrailer] = useState<string>(null);
  const [isAdvModalOpen, setIsAdvModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<any>(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (!id) history.push('/');
  }, [id]);

  useEffect(() => {
    setSerie(getSeries(id));
  }, [series]);

  useEffect(() => {
    if (!hl || !serie) return;
    try {
      document.querySelector(`[data-video-id="${hl}"]`).scrollIntoView({ behavior: 'smooth' });
    } catch {}
  }, [hl, serie]);

  if (!serie) return <FullscreenLoader />;

  return (
    <>
      <Title>{serie.name}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <Button variant={'outline-light'} onClick={() => history.goBack()} className={'mr-2'}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
          <div className={'display-4'}>{serie.name}</div>
        </div>
        {!!serie.description && (
          <blockquote>
            {serie.description.map((segment, i) => (
              <div key={i.toString()}>{segment}</div>
            ))}
          </blockquote>
        )}

        {serie.seasons.flatMap((season) =>
          season.episodes.flatMap((episode) => (
            <Card
              key={episode.id}
              data-video-id={episode.video.id}
              style={{ scrollMarginTop: '200px' }}
              className={'mt-3 ' + (hl == episode.video.id ? 'hl' : '')}
              bg={'dark'}
            >
              <Card.Header className={'d-block d-lg-none'}>
                <Card.Title className={'mb-0'}>{episode.video.title}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className={'d-flex flex-column align-items-center align-items-lg-start flex-lg-row'}>
                  <div className={'mr-0 mr-lg-3 d-flex thumbnail-image-wrapper'} style={{ width: '100%', maxWidth: '300px' }}>
                    <img src={episode.video.sm_thumbnail || episode.video.thumbnail} loading={'lazy'} alt={episode.video.title} />
                  </div>
                  <div className={'d-flex flex-column flex-grow-1 h-100 mt-3 mt-lg-0'}>
                    <h3 className={'d-none d-lg-block'}>{episode.video.title}</h3>
                    {!!episode.video.description && (
                      <div className={'mb-2 text-muted'}>
                        {episode.video.description.map((segment, i) => (
                          <div key={i.toString()}>{segment}</div>
                        ))}
                      </div>
                    )}
                    {!!currentLanguage && currentLanguage.toLowerCase() != 'it' && !!episode.video.languages?.includes(currentLanguage) && (
                      <div className={'mt-2'}>
                        <span className={'border border-secondary px-2 py-1 rounded'}>
                          <CountryFlag language={currentLanguage} />
                          <span className={'small ml-2'}>{t('labels.disponibileInLingua')}</span>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Card.Body>
              <Card.Footer>
                <div className={'mt-2 d-flex flex-column flex-sm-row justify-content-end'}>
                  <div className={'d-flex mr-0 mr-sm-2'}>
                    <MyListButton videoId={episode.video.id} className={'flex-grow-1'} />

                    <Button variant={'info'} disabled={!episode.video.trailer} className={'ml-2 flex-grow-1'} onClick={() => setTrailer(episode.video.trailer)}>
                      <FontAwesomeIcon icon={faFilm} className={'mr-2'} />
                      {t('labels.trailer')}
                    </Button>
                  </div>

                  <div className={'d-flex mt-2 mt-sm-0'}>
                    <VideoRating video={episode.video} className={'mr-2'} />

                    {isVideoLocked(episode.video) ? (
                      <SubscribeButton className={'flex-grow-1'} />
                    ) : (
                      <Button
                        variant={'primary'}
                        className={'flex-grow-1'}
                        onClick={() => {
                          const canUserSeeAdv = shouldSeeAdv({
                            start: new Date(staticData.VIDEO_ADV_START._seconds * 1000),
                            end: new Date(staticData.VIDEO_ADV_END._seconds * 1000),
                          }, {
                            categoriaProfessionale: userDataFmt.profile.formData.categoriaProfessionale,
                            hasAlreadySeenAd: userDataFmt.hasAlreadySeenAd
                          }, staticData, currentLanguage);
                          if (canUserSeeAdv) {
                            setSelectedVideo(episode);
                            setIsAdvModalOpen(true);
                            return;
                          }
                          trackVideoRecommendation(database, fv, currentUser, episode.video).catch(console.error);
                          history.push({
                            pathname: `/watch/${episode.video.parent || episode.video.id}`,
                            search: `s=${id}`,
                          });
                        }}
                      >
                        <FontAwesomeIcon icon={faPlayCircle} className={'mr-2'} />
                        {t('labels.riproduci')}
                      </Button>
                    )}
                  </div>
                </div>
              </Card.Footer>
            </Card>
          ))
        )}
      </Container>

      <Footer />

      <Modal show={!!trailer} onHide={() => setTrailer(null)} centered size={'lg'}>
        <Video src={trailer} preload={'all'} autoPlay={true} controls={true} style={{ width: '100%', borderRadius: '4px' }} />
      </Modal>

      {isAdvModalOpen && !!selectedVideo && (
        <Modal
          className={'dark-modal dark-modal-video'}
          size={'lg'}
          scrollable={false}
          show={isAdvModalOpen}
          backdrop={'static'}
          onHide={() => setIsAdvModalOpen(false)}
          onEscapeKeyDown={() => {
            return;
          }}
        >
          <div>
            <Video
              src={staticData.VIDEO_ADV_SRC}
              preload={'all'}
              autoPlay={true}
              controls={true}
              style={{ width: '100%' }}
              onEnded={async () => {
                await updateUserData({ hasAlreadySeenAd: true });
                trackVideoRecommendation(database, fv, currentUser, selectedVideo.video).catch(console.error);
                history.push({
                  pathname: `/watch/${selectedVideo.video.parent || selectedVideo.video.id}`,
                  search: `s=${id}`,
                });
              }}
            />
          </div>
          <Modal.Footer className="justify-content-center">
            Il messaggio promozionale sta per finire. Appena terminato, verrai portato al video scelto
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default SeriesComponent;
